module.exports = __webpack_public_path__ + "img/logo-login.3bf404d7.png";